module.exports = __webpack_public_path__ + "static/img/00.7a481e6e.png";